import React from 'react'
import { Trans } from '@lingui/macro'

import classes from './SubTitle.module.scss'

export const SubTitle = () => {
  return (
    <h2 className={classes.Subtitle}>
      <Trans>Slow down - you are refreshing too fast!</Trans>
    </h2>
  )
}
